import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MarkovRedistribution } from "server/models"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_MARKOV_MODEL,
    StoreType,

    LoadAllMarkovRedistributions,
    DeleteMarkovRedistribution,

    setMarkovRedistributions,
    setMarkovRedistributionSelected,
    setMarkovRedistributionReloadList,
    addModal,
} from "client/store"
import {
    Collapse,
    Container,
    Loader,
    PageForm,
    FormGroup,
    Label,
    SelectDropdown,
    SelectDropdownItem,
    Button,
    SpinnerIcon,
    Empty,

    PopupMenu,
    PopupMenuItem,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

import EditRedistribution from "client/pages/markov/redistribution/edit"
import RedistributionStateFromList from "client/pages/markov/redistributionStateFrom/list"
import RedistributionStateToList from "client/pages/markov/redistributionStateTo/list"

const actionButtonStyle: React.CSSProperties = {
    marginLeft: "15px",
    transform: "translateY(18px)",
}

const List = () => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const redistributions = useSelector((state: StoreType) => state.markovRedistribution.redistributions)
    const redistributionSelected = useSelector((state: StoreType) => state.markovRedistribution.redistributionSelected)
    const reloadList = useSelector((state: StoreType) => state.markovRedistribution.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)
    const [deleteRedistribution, setDeleteRedistribution] = useState<MarkovRedistribution>(null)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const [showPopup, setShowPopup] = useState(false)
    const [popupTarget, setPopupTarget] = useState<HTMLElement>(null)

    const hideMenu = () => {
        setShowPopup(false)
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllMarkovRedistributions(model && model.id).then((res) => {
            const prevSelected = redistributionSelected && res.find((row) => row.id === redistributionSelected.id)
            dispatch(setMarkovRedistributions(res))
            dispatch(setMarkovRedistributionSelected(prevSelected || (res.length ? res[0] : null)))
            setLoadState(IDLE)
        })
    }, [model, reloadList])

    const closeConfirm = () => {
        setDeleteRedistribution(null)
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteMarkovRedistribution(deleteRedistribution.id, model.id).then(() => {
            dispatch(setMarkovRedistributionReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovRedistributionReloadList(true))
            }, 0)

            setDeleteRedistribution(null)
            setDeleteState(IDLE)
        })
    }

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    return (
        <Collapse
            show={show}
            onCollapse={() => setShow(!show)}
            title={lang.redistributions}
        >
            <Container>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <PageForm row noPaddingBottom>
                    <FormGroup>
                        <Label>{lang.redistributions}</Label>
                        <SelectDropdown title={redistributionSelected ? redistributionSelected.name : <Empty />}>
                            {
                                redistributions.map((redistribution) => (
                                    <SelectDropdownItem
                                        key={redistribution.id}
                                        onClick={() => dispatch(setMarkovRedistributionSelected(redistribution))}
                                    >
                                        {redistribution.name}
                                    </SelectDropdownItem>
                                ))
                            }
                        </SelectDropdown>
                    </FormGroup>
                    {
                        editModelAccess && (
                            <Button
                                after
                                style={actionButtonStyle}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setShowPopup(true)
                                    setPopupTarget(e.target as HTMLElement)
                                }}
                            >
                                {lang.actions}
                            </Button>
                        )
                    }
                </PageForm>
                <RedistributionStateFromList />
                <RedistributionStateToList />

                <PopupMenu
                    show={showPopup}
                    target={popupTarget}
                    placement="bottom-end"
                    showArrow={false}
                >
                    <PopupMenuItem
                        onClick={() => dispatch(addModal({
                            key: "addRedistribution",
                            content: <EditRedistribution redistributionId={0} />,
                        }))}
                    >
                        {lang.add}
                    </PopupMenuItem>
                    {
                        redistributionSelected && (
                            <PopupMenuItem
                                onClick={() => dispatch(addModal({
                                    key: "editRedistribution",
                                    content: <EditRedistribution redistributionId={redistributionSelected.id} />,
                                }))}
                            >
                                {lang.edit}
                            </PopupMenuItem>
                        )
                    }
                    {
                        redistributionSelected && (
                            <PopupMenuItem key="copy">
                                TODO: copy
                            </PopupMenuItem>
                        )
                    }
                    {
                        redistributionSelected && (
                            <PopupMenuItem onClick={() => setDeleteRedistribution(redistributionSelected)}>
                                {lang.delete}
                            </PopupMenuItem>
                        )
                    }
                </PopupMenu>

                <ConfirmWrapper
                    show={!!deleteRedistribution}
                    onClose={closeConfirm}
                >
                    <Confirm>
                        <ConfirmTitle>
                            {deleteRedistribution && deleteRedistribution.name}
                        </ConfirmTitle>
                        <ConfirmDescription>{lang.confirmDeleteRedistribution}</ConfirmDescription>

                        <ConfirmBottom>
                            <Button row onClick={closeConfirm}>{lang.cancel}</Button>
                            <Button variant="success" row onClick={onConfirmDelete}>
                                {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                            </Button>
                        </ConfirmBottom>
                    </Confirm>
                </ConfirmWrapper>
            </Container>
        </Collapse>
    )
}
export default List
